import type { SVGProps } from 'react'

export const Wind = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox='0 0 40 37'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M0.738013 9.0741C0.258309 8.59262 0.221408 7.81484 0.701113 7.29633C2.58303 5.14818 7.56458 0.185215 12.0664 0.3704C18.6716 0.592622 23.4317 10.2593 28.6347 10.4815C31.6236 10.5926 35.4613 7.55558 37.2325 6.03707C37.786 5.55558 38.5978 5.62966 39.0406 6.18521L39.3358 6.55558C39.7786 7.0741 39.7417 7.85188 39.2251 8.33336C37.4539 10 33.0627 13.7037 28.6716 13.5556C21.6974 13.2963 17.5646 3.48151 11.845 3.48151C8.78229 3.48151 4.76015 7.48151 2.98894 9.40744C2.50923 9.96299 1.66052 9.96299 1.14392 9.44447L0.738013 9.0741Z'
      strokeWidth='1.8941'
      strokeMiterlimit='10'
    />
    <path
      d='M0.738013 20.6296C0.258309 20.1482 0.221408 19.3704 0.701113 18.8519C2.58303 16.7037 7.56458 11.7408 12.0664 11.9259C18.6716 12.1482 23.4317 21.8148 28.6347 22.0371C31.6236 22.1482 35.4613 19.1111 37.2325 17.5926C37.786 17.1111 38.5978 17.1852 39.0406 17.7408L39.3358 18.1111C39.7786 18.6296 39.7417 19.4074 39.2251 19.8889C37.417 21.6296 33.0258 25.3333 28.6347 25.1852C21.6605 24.9259 17.5277 15.1482 11.8081 15.1482C8.74539 15.1482 4.72325 19.1482 2.95204 21.0741C2.47233 21.6296 1.62362 21.6296 1.10702 21.1111L0.738013 20.6296Z'
      strokeWidth='1.8941'
      strokeMiterlimit='10'
    />
    <path
      d='M0.738013 32.1852C0.258309 31.7037 0.221408 30.9259 0.701113 30.4074C2.58303 28.2593 7.56458 23.2963 12.0664 23.4815C18.6716 23.7037 23.4317 33.3704 28.6347 33.5556C31.6236 33.6667 35.4613 30.6296 37.2325 29.1111C37.786 28.6296 38.5978 28.7037 39.0406 29.2593L39.3358 29.6296C39.7786 30.1481 39.7417 30.9259 39.2251 31.4074C37.417 33.1482 33.0258 36.8519 28.6347 36.7037C21.6605 36.4444 17.5277 26.6667 11.8081 26.6667C8.74539 26.6667 4.72325 30.6667 2.95204 32.5926C2.47233 33.1481 1.62362 33.1481 1.10702 32.6296L0.738013 32.1852Z'
      strokeWidth='1.8941'
      strokeMiterlimit='10'
    />
  </svg>
)

Wind.toString = () => 'wind'
